module.exports = __webpack_public_path__ + "static/media/404-energie.fea1c47f.png";